module.exports = __webpack_public_path__ + "img/3.21f6bc46.png";